module.exports = __webpack_public_path__ + "img/img_logo.b133b97c.png";